import React from "react";
import { toggle } from "../../../../util/common";
import parse from "html-react-parser";
import { IPackage, IProduct } from "../../../../store/protectionPlanService/business/types";
import { useTranslation } from "react-i18next";

interface IProps {
    index: number;
    product: IProduct;
    packageList?: IPackage[];
}

const BusinessProtectionPlanRow: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();

    const displayProduct = (product?: IProduct) => {
        if (product?.icon === "==cross==") {
            return (
                <div className="plan-icon">
                    <em className="las la-times" title="Not included in Package"></em>{" "}
                    <span className="sr-only">{tLang("manageAccount.protectionPlan.notIncluded")}</span>
                </div>
            );
        } else if (product?.icon === "==tick==") {
            return (
                <div className="plan-icon">
                    <em className="las la-check-circle" title="Included in Package"></em>{" "}
                    <span className="sr-only">{tLang("manageAccount.protectionPlan.included")}</span>
                </div>
            );
        } else {
            return product?.labelText;
        }
    };

    const showProductDetail = (detailDesc?: string) => {
        if (detailDesc) {
            return parse(detailDesc?.replace("bulleted_list serviceDescription", "list-default list-condensed"));
        }
    };

    return (
        <React.Fragment>
            <tr className={`service-group service-group-${props.product.id}`}>
                <th className="row-label" scope="row">
                    <div className="drawer-container">
                        <div className="drawer-header">
                            <button
                                aria-expanded="false"
                                className="btn-default btn-toggle btn-table-drawer"
                                id={`btn-feature-${props.product.id}-${props.index}`}
                                onClick={() => {
                                    toggle(`feature-${props.product.id}-${props.index}`, `btn-feature-${props.product.id}-${props.index}`);
                                }}
                            >
                                <span className="btn-toggle-status sr-only">{tLang("manageAccount.protectionPlan.btn.show")}</span>
                                <span className="btn-text">{props.product.displayName && <React.Fragment>{parse(props.product.displayName)}</React.Fragment>}</span>
                            </button>
                        </div>
                        <div className="drawer-content" id={`feature-${props.product.id}-${props.index}`} style={{ display: "none" }}>
                            <h3 className="sr-only">{props.product.displayName}</h3>
                            <span>{showProductDetail(props.product.description)}</span>
                        </div>
                    </div>
                </th>
                {props.packageList?.map((pkg, pkgIndex: number) => (
                    <React.Fragment key={["product-icon", props.product.id, props.index, pkgIndex].join("-")}>
                        <td className="row-cell">{displayProduct(pkg?.Products?.find((it: IProduct) => props.product.id === it.id))}</td>
                    </React.Fragment>
                ))}
            </tr>
        </React.Fragment>
    );
};

export default BusinessProtectionPlanRow;
